import React, { useEffect, useRef, useState } from "react";
import { IoIosPaper } from "react-icons/io";
import moment from "moment";

import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../components/common/TextInput/TextInput";
import CustomDatePicker from "../../../components/common/DatePicker/CustomDatePicker";
import CustomTable from "../../../components/common/Table/CustomTable";

import { initFilterInput, renderPaymentNonCashColumns } from "../constants";

import "../styles.css";
import httpclient from "../../../components/httpclient";
import SwalToast from "../../../components/helpers/SwalToast";
import { convertNonCashPaymentList } from "./helpers/convertNonCashPaymentList";
import PreviewImage from "../../../components/common/PreviewImage/PreviewImage";
import { Modal, Button, Input } from "antd";
import IsEmpty from "../../../components/helpers/IsEmpty";

const PaymentNonCash = () => {
  const pageSizeRef = useRef();
  const searchNameRef = useRef();
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [dateValue, setDateValue] = useState([]);
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [modalReject, setModalReject] = useState(false);
  const [modalApprove, setModalApprove] = useState(false);
  const [reason, setReason] = useState("");
  const [errorReason, setErrorReason] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const handleDateChange = (event) => {
    setDateValue([moment(event[0]._d), moment(event[1]._d)]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(event[0]._d) : null,
      transactionEndDate: event ? new Date(event[1]._d) : null,
    }));
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;
        if (event.keyCode === 13 || type === "blur") {
          setFilterInput((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      };

  const handleAcceptButtonClick = (gadaiID) => {
    setModalApprove(true);
    console.log("acc");
    setSelectedId(gadaiID);
  };

  const handleRejectButtonClick = (gadaiID) => {
    console.log("batalkan");
    setModalReject(true);
    setSelectedId(gadaiID);
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      size: parseInt(pagination.pageSize),
    }));
  };

  useEffect(() => {
    pageSizeRef.current.value = 10;
  }, []);

  useEffect(() => {
    console.log(filterInput);
    getData();
  }, [filterInput]);

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const getData = () => {
    setLoading(true);
    const data = {
      search: filterInput.searchName,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      page: parseInt(filterInput.page),
      page_size: parseInt(filterInput.pageSize),
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/manual-transfer/list`;
    httpclient
      .GET(url, data)
      .then((res) => {
        setRecords(
          convertNonCashPaymentList(res.data.data.items, handleOpenPreview)
        );
        setTablePagination({
          current: res.data.data.page,
          pageSize: res.data.data.per_page,
          total: res.data.data.total_item,
        });
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      });
  };

  const handleReject = () => {
    const data = {
      gadai_id: selectedId,
      notes: reason,
    };
    if (IsEmpty(reason)) {
      setErrorReason(true);
    } else {
      let url = `${process.env.REACT_APP_BASE_API_URL}gadai/manual-transfer/reject`;
      httpclient
        .POST(url, data)
        .then((res) => {
          SwalToast.fire({
            icon: "success",
            title: res.data.message,
          });
          handleCloseModal();
          getData()
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        });
    }
  };

  const handleApprove = () => {
    const data = {
      gadai_id: selectedId,
      // notes: reason,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/manual-transfer/approve`;
    httpclient
      .POST(url, data)
      .then((res) => {
        SwalToast.fire({
          icon: "success",
          title: res.data.message,
        });
        handleCloseModal();
        getData()
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response.data.error);
          SwalToast.fire({
            icon: "error",
            title: error.response.data.error.message,
          });
        } else {
          console.log(error);
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      });
  };
  const handleCloseModal = () => {
    setModalApprove(false);
    setModalReject(false);
    setSelectedId();
  };

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pembayaran Non-tunai (Transfer)"} />
            <Breadcrumb current={"Pembayaran Non-tunai (Transfer)"} />
          </div>
          <div className="ml-auto d-flex align-items-center">
            <div className="total-container">
              <IoIosPaper className="total-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>
                {tablePagination.total}
              </span>{" "}
              Pembayaran
            </div>
          </div>
        </div>

        <div className="d-flex filter-bar-2">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            ref={pageSizeRef}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            ref={searchNameRef}
          />
          <CustomDatePicker
            id={"capitalTransaction"}
            label={"Tanggal Pembayaran"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={dateValue}
          />
        </div>

        <CustomTable
          columns={renderPaymentNonCashColumns(
            handleAcceptButtonClick,
            handleRejectButtonClick
          )}
          scrollX={1400}
          data={records}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
        />
      </div>
      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
      <Modal
        className="modal-edit"
        centered
        title={`Terima Pembayaran`}
        visible={modalApprove}
        onOk={handleApprove}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleApprove}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Terima
          </Button>,
        ]}
      >
        <p className="mt-4 color-303030">
          Anda yakin telah menerima pembayaran ini?
        </p>
      </Modal>

      <Modal
        className="modal-reject"
        centered
        title={"Tolak Pembayaran"}
        visible={modalReject}
        onOk={handleReject}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            onClick={handleReject}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#EB2424",
            }}
          >
            Tolak
          </Button>,
        ]}
      >
        <div className="mt-2 d-flex">
          <div className="color-A6A6A6" style={{ flex: 1 }}>
            Alasan :
          </div>
          <div style={{ flex: 3 }}>
            <Input.TextArea
              required
              type="text"
              className="border-DCDCDC text-input"
              onChange={(e) => setReason(e.target.value)}
              rows={4}
            />
            {errorReason ? (
              <span className="small text-danger">Alasan harus diisi</span>
            ) : null}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PaymentNonCash;
